import { FC, ReactElement } from 'react'

export const Social: FC = (): ReactElement => (
  <ul className="form-buttons">
    <li>
      <a href={process.env.REACT_APP_GOOGLE_LOGIN_URL}>
        <i className="hb-ico soc-3" />
        Sign in with Google
      </a>
    </li>
    <li>
      <a href={process.env.REACT_APP_AMAZON_LOGIN_URL}>
        <i className="hb-ico soc-1" />
        Sign in with Amazon
      </a>
    </li>
  </ul>
)
